// extracted by mini-css-extract-plugin
module.exports = {"countryArea":"CountryArea_countryArea__eCcGR","pagination":"CountryArea_pagination__29eLi","countries":"CountryArea_countries__2zfEA"};